import { clsx } from 'clsx';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import CarpetIcon from 'src/shared/assets/icons/carpet-nav.svg';
import DashboardIcon from 'src/shared/assets/icons/dashboard-nav.svg';
import { ROUTES } from 'src/shared/constants/routes';
import { useStore } from 'src/store';
import {
  GOPLAN_DASHBOARD_ACCESS,
  GOPLAN_DRILLING_CARPET_GRAPH_EDIT,
  GOPLAN_DRILLING_CARPET_GRAPH_READ,
  GOPLAN_DRILLING_CARPET_PREPARATION_ACCESS_EDIT,
  GOPLAN_DRILLING_CARPET_PREPARATION_ACCESS_READ,
  GOPLAN_DRILLING_CARPET_WELL_CLUSTER_ACCESS_READ,
  GOPLAN_DRILLING_CARPET_WELLS_ACCESS_EDIT,
  GOPLAN_DRILLING_CARPET_WELLS_ACCESS_READ,
} from 'src/store/roles-store/roles';

import { MenuItem } from '../menu-item/menu-item';

import styles from './styles.module.scss';

type Props = {
  isOpened: boolean;
};

export const Navigation: React.FC<Props> = observer(function Navigation({ isOpened }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { rolesStore } = useStore();

  const navProps = useMemo(() => {
    const navItems = [];

    if (
      rolesStore.hasAccess([
        GOPLAN_DRILLING_CARPET_GRAPH_READ,
        GOPLAN_DRILLING_CARPET_GRAPH_EDIT,
        GOPLAN_DRILLING_CARPET_WELL_CLUSTER_ACCESS_READ,
        GOPLAN_DRILLING_CARPET_WELLS_ACCESS_READ,
        GOPLAN_DRILLING_CARPET_WELLS_ACCESS_EDIT,
        GOPLAN_DRILLING_CARPET_PREPARATION_ACCESS_READ,
        GOPLAN_DRILLING_CARPET_PREPARATION_ACCESS_EDIT,
      ])
    ) {
      navItems.push({
        name: 'Nav.carpet',
        to: ROUTES.carpet,
        renderIcon: (className: string) => <CarpetIcon className={className} />,
      });
    }

    if (rolesStore.hasAccess([GOPLAN_DASHBOARD_ACCESS])) {
      navItems.push({
        name: 'Nav.dashboard',
        to: ROUTES.dashboard,
        renderIcon: (className: string) => <DashboardIcon className={className} />,
      });
    }

    return navItems;
  }, [rolesStore]);

  return (
    <div className={clsx(styles.wrapper, isOpened && styles.wrapper__opened)}>
      {navProps.map((nav) => {
        const isActive = location.pathname.includes(nav.to.replaceAll(/[*/]/g, ''));
        const onClick = () => navigate(nav.to);

        return <MenuItem key={nav.to} isActive={isActive} isOpened={isOpened} item={nav} onClick={onClick} />;
      })}
    </div>
  );
});
